/*
 * product-easify.js
 *
 * Horizontal description tabs for the pixiu-crystal-bracelet-easify
 * template, Sarah & Sebastian style. The tab panels are the existing
 * "serenity" accordion blocks in the template JSON; this script only
 * builds a tab bar from their headings and toggles an
 * easify-tab-active class. product-easify.css shows the bar and hides
 * the accordion headers on desktop; below 768px the bar is hidden and
 * the original accordion keeps working untouched.
 *
 * Loaded from sections/main-product.liquid for this suffix only.
 */
(function () {
    function init() {
        var tabs = Array.prototype.slice.call(
            document.querySelectorAll('.productView .serenity-tab')
        );
        if (!tabs.length) return;

        var bar = document.createElement('div');
        bar.className = 'easify-tab-bar';

        tabs.forEach(function (tab, i) {
            var heading = tab.querySelector('.serenity-tab-header span');
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = heading ? heading.textContent : 'Tab ' + (i + 1);
            btn.addEventListener('click', function () {
                /* No scroll correction needed: the tabs live outside the
                 * sticky buy column (see moveTabsBelowColumns), so resizing
                 * a panel can't re-pin anything - the tab strip and the
                 * gallery both stay put. Just swap which panel is open. */
                tabs.forEach(function (t) { t.classList.remove('easify-tab-active'); });
                Array.prototype.forEach.call(bar.children, function (b) {
                    b.classList.remove('active');
                });
                tab.classList.add('easify-tab-active');
                btn.classList.add('active');
            });
            bar.appendChild(btn);
        });

        tabs[0].parentNode.insertBefore(bar, tabs[0]);
        tabs[0].classList.add('easify-tab-active');
        bar.firstChild.classList.add('active');
        document.body.classList.add('easify-tabs-on');
    }

    /* The slide-show video ships with autoplay/muted attributes but the
     * theme's slider JS can leave it paused. Force-play it (muted) when
     * it scrolls into view, pause it when it leaves.
     *
     * Also covers the gallery video (.productView-video, rendered when
     * the section's Video layout is "thumbnail"). The theme emits that
     * one with controls and no autoplay attributes, so it sits paused
     * until this runs. Muted + playsinline is what lets browsers
     * autoplay at all; controls stay so the customer can pause it. */
    function videoAutoplay() {
        var vids = document.querySelectorAll(
            '.sections-slide-show video, .productView-video video, .easify-video-item video'
        );
        if (!vids.length) return;

        var tryPlay = function (v) {
            v.muted = true;
            v.setAttribute('playsinline', '');
            v.setAttribute('loop', '');
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
        };

        if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        tryPlay(entry.target);
                    } else {
                        entry.target.pause();
                    }
                });
            }, { threshold: 0.25 });
            Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
        } else {
            Array.prototype.forEach.call(vids, tryPlay);
        }
    }

    /* Progress line under the mobile swipe gallery: the filled segment's
     * width is the visible fraction, its position tracks scrollLeft. */
    function galleryProgress() {
        var nav = document.querySelector('.productView-nav.stacked-gallery');
        if (!nav) return;

        var track = document.createElement('div');
        track.className = 'easify-gallery-progress';
        var fill = document.createElement('span');
        track.appendChild(fill);
        nav.parentNode.insertBefore(track, nav.nextSibling);

        var raf = null;
        var update = function () {
            raf = null;
            var total = nav.scrollWidth;
            if (!total) return;
            var frac = nav.clientWidth / total;
            fill.style.width = (frac * 100) + '%';
            fill.style.transform = 'translateX(' + (nav.scrollLeft / nav.clientWidth * 100) + '%)';
        };
        nav.addEventListener('scroll', function () {
            if (!raf) raf = requestAnimationFrame(update);
        }, { passive: true });
        window.addEventListener('resize', update);
        update();
    }

    /* Clicking a variant choice shows that choice's photo AS THE HERO.
     * The stacked gallery has no slider, so the theme's own
     * variant->media scroll does nothing here. variant-radios embeds the
     * variants as JSON (featured_media included); on change, match the
     * checked option values to a variant and move its photo into the
     * first slot. Scrolling to the photo was tried first and read as the
     * page jumping away on long galleries. Delegated on document so it
     * survives any section re-render. */
    function variantPhotoSync() {
        document.addEventListener('change', function (e) {
            var radio = e.target;
            if (!radio.classList || !radio.classList.contains('product-form__radio')) return;
            var vr = radio.closest('variant-radios, variant-sticky-radios');
            if (!vr) return;
            var jsonEl = vr.querySelector('script[type="application/json"]');
            if (!jsonEl) return;
            var variants;
            try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

            var picked = [];
            vr.querySelectorAll('fieldset').forEach(function (fs) {
                var c = fs.querySelector('input[type="radio"]:checked');
                if (c) picked.push(c.value);
            });
            var match = variants.find(function (v) {
                return v.options.length === picked.length && v.options.every(function (o, i) { return o === picked[i]; });
            });
            if (!match || !match.featured_media) return;

            var nav = document.querySelector('.productView-nav.stacked-gallery');
            if (!nav) return;
            var chosen = nav.querySelector('.productView-image[data-index="' + match.featured_media.position + '"]');
            var first = nav.querySelector('.productView-image');
            if (!chosen || !first || chosen === first) return;

            /* Swap the chosen variant's photo into the hero slot rather than
             * scrolling to it: on a long gallery a scroll reads as the page
             * jumping away. Remember where each photo started so repeated
             * picks put the previous hero back in its own place instead of
             * shuffling the gallery further each time. */
            Array.prototype.forEach.call(nav.children, function (el, i) {
                if (el.dataset.homeIndex === undefined) el.dataset.homeIndex = i;
            });
            nav.insertBefore(chosen, first);
            Array.prototype.slice.call(nav.children)
                .filter(function (el) { return el !== chosen; })
                .sort(function (a, b) { return a.dataset.homeIndex - b.dataset.homeIndex; })
                .forEach(function (el) { nav.appendChild(el); });
        });
    }

    /* Register look for variant options: no boxes, no photo-swatch
     * circles - every choice is plain text with the underline on the
     * selected one (like the Pixiu register). The theme renders
     * image-swatch options as an empty label holding only a photo
     * span.pattern (no text), so replace the photo with the option's
     * name from its radio input. */
    function textifySwatches() {
        document.querySelectorAll('.productView-options .product-form__label').forEach(function (label) {
            var pattern = label.querySelector('.pattern');
            if (!pattern) return;
            var radio = document.getElementById(label.getAttribute('for')) ||
                label.previousElementSibling;
            var value = radio && radio.value ? radio.value : null;
            if (!value) return;
            pattern.remove();
            var span = document.createElement('span');
            span.className = 'text';
            span.textContent = value;
            label.appendChild(span);
        });
    }

    /* Wrist Size is always a dropdown. Twelve wrist measurements laid
     * out as inline text swamp the buy column, and the Pixiu register
     * already presents this option as an underline dropdown - match it
     * on the simple template. Build a <select> from the radios, keep
     * the radios in the DOM (visually hidden) so the theme's own
     * variant logic keeps working, and mirror changes both ways. */
    function wristSizeDropdown() {
        document.querySelectorAll('.productView-options fieldset.product-form__input').forEach(function (fs) {
            if (fs.dataset.wristDd === '1') return;
            var legend = fs.querySelector('legend');
            if (!legend || !/wrist size/i.test(legend.textContent)) return;

            var radios = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
            /* Only collapse genuinely long lists (the 12 wrist measurements).
             * A 2-3 option size row reads better as inline text. */
            if (radios.length < 5) return;
            fs.dataset.wristDd = '1';

            var select = document.createElement('select');
            select.className = 'easify-wrist-select';
            radios.forEach(function (radio) {
                var opt = document.createElement('option');
                opt.value = radio.value;
                opt.textContent = radio.value;
                if (radio.checked) opt.selected = true;
                select.appendChild(opt);
            });

            select.addEventListener('change', function () {
                var target = radios.filter(function (r) { return r.value === select.value; })[0];
                if (!target || target.checked) return;
                /* Drive the radio the way a real tap does - check it, then
                 * fire ONE change event that bubbles to variant-radios.
                 * (click() re-entered the theme's handler and left the form
                 * with duplicate hidden [name=id] inputs.) */
                radios.forEach(function (r) { r.checked = (r === target); });
                target.dispatchEvent(new Event('change', { bubbles: true }));
            });

            /* Keep the dropdown honest if anything else changes the variant. */
            radios.forEach(function (radio) {
                radio.addEventListener('change', function () {
                    if (radio.checked) select.value = radio.value;
                });
            });

            fs.classList.add('easify-wrist-row');
            fs.appendChild(select);
        });
    }

    function ready() {
        init();
        videoAutoplay();
        galleryProgress();
        variantPhotoSync();
        textifySwatches();
        wristSizeDropdown();

        /* The theme re-renders the options block on every variant change,
         * which throws away the injected dropdown (and un-textifies the
         * swatches). Rebuild them whenever that markup is replaced. */
        var optionsHost = document.querySelector('.productView-options');
        if (optionsHost && 'MutationObserver' in window) {
            var rebuilding = false;
            new MutationObserver(function () {
                if (rebuilding) return;
                rebuilding = true;
                requestAnimationFrame(function () {
                    textifySwatches();
                    wristSizeDropdown();
                    rebuilding = false;
                });
            }).observe(optionsHost, { childList: true, subtree: true });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ready);
    } else {
        ready();
    }
})();
